import type {TFunction} from 'i18next'

/** `segment_key` («11-50|I-III») lo arma `core/partner.py::segment_key`; uno desconocido sale crudo. */
export function formatSegmentKey(key: string, t: TFunction): string {
  const [size, risk] = key.split('|')
  if (!size || !risk) return key
  return t('planFacturacion.segments.combined', {
    size: formatSizeBand(size, t),
    risk: formatRiskGroup(risk, t),
  })
}

function formatSizeBand(size: string, t: TFunction): string {
  return t(`planFacturacion.segments.size.${size}`, {defaultValue: size})
}

export function formatSizeBandShort(size: string, t: TFunction): string {
  return t(`planFacturacion.segments.sizeShort.${size}`, {defaultValue: size})
}

export function formatRiskGroup(risk: string, t: TFunction): string {
  return t(`planFacturacion.segments.risk.${risk}`, {defaultValue: risk})
}
